import { Routes } from '@angular/router';
import { adminGuard, authGuard, guestGuard } from './core/guards/auth.guard';
import { betaRegisterGuard } from './core/guards/beta-register.guard';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./shared/layouts/public-layout/public-layout.component').then(
        (m) => m.PublicLayoutComponent,
      ),
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./features/landing/landing.component').then((m) => m.LandingComponent),
      },
      {
        path: 'contact',
        title: 'landing.contact.pageTitle',
        loadComponent: () =>
          import('./features/contact/contact.component').then((m) => m.ContactComponent),
      },
      {
        path: 'pricing',
        title: 'landing.pricingSection.pageTitle',
        loadComponent: () =>
          import('./features/pricing/pricing-page.component').then((m) => m.PricingPageComponent),
      },
      {
        path: 'legal/terms',
        title: 'legal.terms.pageTitle',
        loadComponent: () =>
          import('./features/legal/terms-of-service/terms-of-service.component').then(
            (m) => m.TermsOfServiceComponent,
          ),
      },
      {
        path: 'legal/privacy',
        title: 'legal.privacy.pageTitle',
        loadComponent: () =>
          import('./features/legal/privacy-policy/privacy-policy.component').then(
            (m) => m.PrivacyPolicyComponent,
          ),
      },
      {
        path: 'legal/acceptable-use',
        title: 'legal.acceptableUse.pageTitle',
        loadComponent: () =>
          import('./features/legal/acceptable-use/acceptable-use.component').then(
            (m) => m.AcceptableUseComponent,
          ),
      },
      {
        path: 'login',
        title: 'auth.login.pageTitle',
        loadComponent: () =>
          import('./features/auth/login.component').then((m) => m.LoginComponent),
        canActivate: [guestGuard],
      },
      {
        path: 'register',
        title: 'auth.register.pageTitle',
        loadComponent: () =>
          import('./features/auth/register/register').then((m) => m.RegisterComponent),
        canActivate: [betaRegisterGuard, guestGuard],
      },
      {
        path: 'verify-email',
        title: 'auth.verifyEmail.pageTitle',
        loadComponent: () =>
          import('./features/auth/verify-email/verify-email').then((m) => m.VerifyEmailComponent),
      },
      {
        path: 'forgot-password',
        title: 'auth.forgotPassword.pageTitle',
        loadComponent: () =>
          import('./features/auth/forgot-password/forgot-password').then(
            (m) => m.ForgotPasswordComponent,
          ),
        canActivate: [guestGuard],
      },
      {
        path: 'reset-password',
        title: 'auth.resetPassword.pageTitle',
        loadComponent: () =>
          import('./features/auth/reset-password/reset-password').then((m) => m.ResetPassword),
      },
      {
        path: 'resend-verification',
        title: 'auth.resendVerification.pageTitle',
        loadComponent: () =>
          import('./features/auth/resend-verification/resend-verification.component').then(
            (m) => m.ResendVerificationComponent,
          ),
        canActivate: [guestGuard],
      },
    ],
  },
  {
    path: 'profile',
    redirectTo: 'dashboard/profile',
    pathMatch: 'full',
  },
  {
    path: '',
    loadComponent: () =>
      import('./shared/layouts/dashboard-layout/dashboard-layout.component').then(
        (m) => m.DashboardLayoutComponent,
      ),
    canActivate: [authGuard],
    children: [
      {
        path: 'dashboard',
        data: { breadcrumb: 'dashboard.dashboardShell.topbar.workspace' },
        loadChildren: () =>
          import('./features/dashboard/dashboard.routes').then((m) => m.dashboardRoutes),
      },
    ],
  },
  {
    path: 'admin',
    loadComponent: () =>
      import('./shared/layouts/admin-layout/admin-layout.component').then(
        (m) => m.AdminLayoutComponent,
      ),
    canActivate: [authGuard, adminGuard],
    data: { breadcrumb: 'admin.adminShell.topbar.console' },
    loadChildren: () => import('./features/admin/admin.routes').then((m) => m.adminRoutes),
  },
  {
    path: '**',
    redirectTo: '',
  },
];
